import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { useState } from "react";

import { useLocalePaths } from "@/features/i18n/LocalePathContext";

const locales = ["en", "no"] as const;

type Locale = (typeof locales)[number];

const useLanguageCurrency = () => {
  const router = useRouter();
  const localePaths = useLocalePaths();

  const [isOpen, setOpen] = useState(false);

  const locale = router.locale;

  const setLocale = (nextLocale: Locale) => {
    Cookies.set("NEXT_LOCALE", nextLocale, {
      expires: 365,
    });

    const targetPath = localePaths?.[nextLocale] ?? router.asPath.split("?")[0];

    router.push(targetPath, undefined, {
      locale: nextLocale,
      scroll: false,
    });
  };

  const languages = {
    en: {
      name: "English",
      isSelected: locale === "en",
      select: () => {
        setLocale("en");
      },
      locale: "en",
    },

    no: {
      name: "Norsk",
      isSelected: locale === "no",
      select: () => {
        setLocale("no");
      },
      locale: "no",
    },
  };

  const languageArray = Object.keys(languages).map((key) => {
    return {
      ...languages[key as Locale],
      locale: key as Locale,
    };
  });

  const selectedLanguage =
    languages[(router.locale as keyof typeof languages) || "en"];

  const toggleOpenLang = () => {
    setOpen(!isOpen);
  };

  return {
    setLocale,
    locale: router.locale ?? "en",
    languages: languageArray,
    selectedLanguage,
    openLang: isOpen,

    toggleOpenLang,
  };
};

export default useLanguageCurrency;
